import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[normalizeInput]'
})
export class NormalizeInputDirective {

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInputChange(event: any) {
    // Nunca tocar no input durante composição (dead keys/IME): reatribuir .value
    // aqui cancela a composição e o acento entra cru ("´a" em vez de "á").
    if (event?.isComposing) return;
    this.normalize();
  }

  // fim da composição (´ + a = á): agora é seguro normalizar
  @HostListener('compositionend') onCompositionEnd() {
    this.normalize();
  }

  private normalize() {
    const value = this.el.nativeElement.value;
    const normalizedValue = this.normalizeText(value);
    // só reatribui quando a normalização muda algo — reatribuição incondicional
    // quebrava dead keys e jogava o cursor para o fim a cada tecla
    if (normalizedValue === value) return;
    this.el.nativeElement.value = normalizedValue;

    if (this.control && this.control.control) {
      this.control.control.setValue(normalizedValue, { emitEvent: false });
    }
  }

  normalizeText(value: string): string {
    if(!value){
      return '';
    }

    return value.normalize('NFKC');
  }
}
